import axios from "../config/axios-chatbot";
import qs from "qs";
import {currentProtectionProjectId, getFlowProtectionToken} from "../utils/flowProtectionStorage";

// Attaches the message protection unlock token of the open registry project (see flowProtectionStorage), if one exists.
const protectionHeaders = () => {
    const protectionToken = getFlowProtectionToken(currentProtectionProjectId());
    return protectionToken ? {"X-Protection-Token": protectionToken} : {};
};

export const ConversationRepository = {
    getStatusStatistic: ({flowUid, type, startDate, endDate, signal}) =>
        axios.get(`/api/conversation/statistics/status`, {
            params: {
                flow: flowUid,
                type,
                start: startDate,
                end: endDate
            },
            signal,
            headers: protectionHeaders()
        }),
    // signal: aborts the request (not sent as a query parameter)
    getConversations: ({signal, ...params}) =>
        axios.get(`/api/conversation`, {
            params: {...(params || {})},
            signal,
            paramsSerializer: (params) =>
                qs.stringify(params, {arrayFormat: "repeat"}), // <-- key fix
            headers: protectionHeaders()
        }),
    // Every conversation matching the getConversations filters (not paged) as a CSV file (Blob)
    exportConversations: ({...params}) =>
        axios.get(`/api/conversation/export`, {
            params: {...(params || {})},
            paramsSerializer: (params) => qs.stringify(params, {arrayFormat: "repeat"}),
            responseType: "blob",
            headers: protectionHeaders()
        }),
    getConversation: ({id}) => axios.get(`/api/conversation/${id}`, {
        headers: protectionHeaders()
    }),
    getPrevAndNext: ({id, ...params}) => axios.get(`/api/conversation/${id}/navigation`, {
        params: {...(params || {})},
        headers: protectionHeaders()
    }),
    handoverToAgent: ({id, username, vdn}) => axios.post(`/api/conversation/${id}/handover`, {
        id: id,
        username: username,
        vdn: vdn
    }, {headers: protectionHeaders()}),
    toggleResolved: ({id}) => axios.post(`/api/conversation/${id}/toggle-resolve`, undefined, {
        headers: protectionHeaders()
    }),
    monitorConversation: ({id, username}) => axios.post(`/api/conversation/${id}/monitoring`, {
        id: id,
        username: username
    }, {headers: protectionHeaders()}),
    initiateConversation: ({body, params}) => axios.post(`/api/conversation/call-over`, body, {
        params: {...(params || {})},
        headers: protectionHeaders()
    }),
    getMessages: (id, signal) => axios.get(`/api/conversation/${id}/messages`, {
        signal,
        headers: protectionHeaders()
    }),
    getHistory: ({id, caller, type, page, size}) => axios.get(`/api/conversation/history`, {
        params: {
            id,
            caller,
            type,
            page,
            size
        },
        headers: protectionHeaders()
    }),
    createConversation: (data) => axios.post("/api/conversation", data, {
        headers: protectionHeaders()
    }),
    // Audio by id (the stored paths are server-side only). Blob responses: play them from a blob URL, an <audio src>
    // cannot send the Authorization header (see utils/audioLoader). download: true = Content-Disposition attachment.
    getConversationAudio: ({id, download, signal}) => axios.get(`/api/conversation/${id}/audio`, {
        params: download ? {download: true} : {},
        responseType: "blob",
        signal,
        headers: protectionHeaders()
    }),
    getMessageAudio: ({conversationId, messageId, download, signal}) =>
        axios.get(`/api/conversation/${conversationId}/messages/${messageId}/audio`, {
            params: download ? {download: true} : {},
            responseType: "blob",
            signal,
            headers: protectionHeaders()
        }),
    sendMessage: ({id, message}) => axios.post(`/api/conversation/${id}/send`, {message, conversation: id}, {
        headers: protectionHeaders()
    }),
    getNodeUsage: (ids) => {
        const query = ids.map(id => `ids=${encodeURIComponent(id)}`).join('&');
        return axios.get(`/api/conversation/statistics/node-usage?${query}`, {
            headers: protectionHeaders()
        })
    },
    likeConversation: ({id, likeType, username}) => axios.post(`/api/conversation/${id}/interactions/likes`, {
        likeType,
        username
    }, {headers: protectionHeaders()}),
    removeLike: ({id, likeId}) => axios.delete(`/api/conversation/${id}/interactions/likes/${likeId}`, {
        headers: protectionHeaders()
    }),

    commentConversation: ({id, text, username}) => axios.post(`/api/conversation/${id}/interactions/comments`, {
        text,
        username
    }, {headers: protectionHeaders()}),
    removeComment: ({id, commentId}) => axios.delete(`/api/conversation/${id}/interactions/comments/${commentId}`, {
        headers: protectionHeaders()
    }),

}
